import rootSlice from './slice';

const suggestedPeopleReducer = rootSlice.reducer;

export default suggestedPeopleReducer;
